import { Button } from "./ui/button";
import { ArrowRight, Play } from "lucide-react";
// import heroImage from 'figma:asset/61b391147addfc947b4e4fe92e1a09823f02677a.png';
import heroImage from '../Assets/hero.png';

export function Hero() {
  return (
    <section className="relative overflow-hidden py-12 lg:py-20" style={{ backgroundColor: '#819A40' }}>
      {/* Light Yellow Gradient from Top Right Corner */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(circle at top right, rgba(253, 216, 53, 0.3) 0%, rgba(253, 216, 53, 0.15) 25%, rgba(253, 216, 53, 0.05) 50%, transparent 70%)'
        }}
      ></div>
      
      {/* Background Pattern Overlay */}
      <div className="absolute inset-0 bg-grid-pattern opacity-10"></div>
      
      {/* Content */}
      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Column - Text and Buttons */}
          <div className="text-center lg:text-left">
            <h1 className="mb-4 text-2xl lg:text-4xl text-white">
              AI-Driven Procurement and Scheme Management for the{" "}
              <span style={{ color: '#FDD835' }}>
                Modern Retail Enterprise
              </span>
            </h1>
            <p className="mb-6 text-base text-white/90 lg:text-lg">
              Transform how you manage procurement, promotions, schemes, and auctions—all on one intelligent platform.
            </p>
            <div className="flex flex-col items-center lg:items-start justify-center lg:justify-start gap-3 sm:flex-row">
              <Button size="lg" className="group bg-white font-semibold hover:bg-gray-100" style={{ color: '#819A40' }}>
                Request a Demo
                <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Button>
              <Button 
                size="lg" 
                className="group text-white font-semibold hover:opacity-90 transition-opacity"
                style={{ backgroundColor: '#FF814C' }}
              >
                <Play className="mr-2 h-4 w-4" />
                Explore Solutions
              </Button>
            </div>
          </div>

          {/* Right Column - Image */}
          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              <img 
                src={heroImage} 
                alt="NexProcureAI Dashboard Interface"
                className="w-full max-w-3xl lg:max-w-5xl xl:max-w-6xl 2xl:max-w-7xl h-auto object-contain drop-shadow-2xl"
              />
              {/* Optional glow effect behind image */}
              <div className="absolute inset-0 bg-white/20 rounded-lg blur-3xl -z-10 scale-110"></div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute top-1/4 left-4 w-20 h-20 bg-white/10 rounded-full blur-xl"></div>
      <div className="absolute bottom-1/4 right-8 w-32 h-32 bg-white/10 rounded-full blur-xl"></div>
      <div className="absolute top-1/2 left-1/3 w-16 h-16 bg-white/5 rounded-full blur-lg"></div>
    </section>
  );
}